import query from "./query/en";

export default {
  label: "Groups",
  createGroup: "Create Group",
  updateGroup: "Update Group",
  groupDetails: "Group Details",
  query,
};
